export { TotalCoinsText } from './TotalCoinsText';
